class FulfilmentWizardService {
    constructor($rootScope, fulfilmentService, fulfilmentTimeslotService) {
        this.$rootScope = $rootScope;
        this.fulfilmentService = fulfilmentService;
        this.fulfilmentTimeslotService = fulfilmentTimeslotService;

        this.timeTableLoading = false;
        this.timeTable = [];
        this.currentStep = null;

        this.editEvents = {
            fulfilmentMethod: 'fulfilmentWizard:editFulfilmentMethod',
            timeSlot: 'fulfilmentWizard:editTimeSlot',
        };
    }

    editFulfilmentMethod() {
        this.$rootScope.$broadcast('fulfilmentWizard:editFulfilmentMethod');
    }

    editTimeSlot() {
        this.$rootScope.$broadcast('fulfilmentWizard:editTimeSlot');
    }

    hasSelectedTimeslot() {
        return !!(this.fulfilmentService.reservedDate
            && this.fulfilmentService.reservedTime
            && this.fulfilmentService.reservedDate.DateText
            && this.fulfilmentService.reservedTime.TimeWindow
        );
    }

    hasAvailableTimeSlots() {
        return this.timeTable && this.timeTable.some(x => x.Available);
    }
}

FulfilmentWizardService.$inject = ['$rootScope', 'FulfilmentService', 'FulfilmentTimeslotService'];

module.exports = FulfilmentWizardService;



// WEBPACK FOOTER //
// ./src/fulfilment/fulfilment-wizard.service.js